import React from "react";
import { AdminDashboard } from "../design-system/components/admin/AdminDashboard";


export default function Admin(){

  return (
    <AdminDashboard />
  );

}